module.exports = __webpack_public_path__ + "static/media/sort_desc.b435f4b4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sort_desc.svg
// module id = 1052
// module chunks = 3